import React from "react";
import styled from "styled-components";
import back from '../../assets/back.svg';

const Container = styled.div`
  height: 50px;
  background: #141624;
  display: flex;
  align-items: center;
`;

const BackArrow = styled.img`
  height: 48px;
  padding: 10px;
`;


const Title = styled.span`
    font-family: 'Poppins';
    font-style: normal;
    /* font-weight: 500; */
    font-size: 20px;
    line-height: 24px;
    color: #FFFFFF;
`;

export const Header = (props) => {
  return (
      <Container>
        <BackArrow onClick={() => {
          if (window.androidEmbeded) {
            window.backPressed();
            window.unSubscribeBackPress();
          } else {
            props?.backPress?.()
          }
          window.analytics.track('backPressed', {
            item: 'header',
          });
        }} src={back}/>
        <Title>{props.title}</Title>
      </Container>
  );
}